import React from 'react';
import { CheckCircle2, Heart, Sparkles, X } from 'lucide-react';

interface NotificationToastProps {
  message: string | null;
  type?: 'success' | 'heart' | 'info';
  onClose: () => void;
}

export const NotificationToast: React.FC<NotificationToastProps> = ({
  message,
  type = 'success',
  onClose,
}) => {
  if (!message) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-in slide-in-from-bottom-5 fade-in duration-300">
      <div className="bg-slate-900 text-white px-4 py-3 rounded-2xl shadow-2xl flex items-center gap-3 border border-slate-800 max-w-sm">
        {type === 'heart' ? (
          <div className="w-8 h-8 rounded-full bg-pink-500 text-white flex items-center justify-center shrink-0">
            <Heart className="w-4 h-4 fill-white" />
          </div>
        ) : (
          <div className="w-8 h-8 rounded-full bg-emerald-500 text-white flex items-center justify-center shrink-0">
            <CheckCircle2 className="w-4 h-4 text-white" />
          </div>
        )}

        <div className="flex-1 text-xs font-medium leading-tight">
          {message}
        </div>

        <button
          onClick={onClose}
          className="text-slate-400 hover:text-white p-1 rounded-lg"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
